// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nbutton[data-v-dd65ec7a] {\n  top: 0.5rem;\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.2s;\n  padding: 0;\n  background: transparent;\n  border: 0;\n}\nbutton[data-v-dd65ec7a]:hover {\n  transform: scale(1.1);\n}\n", ""]);
// Exports
module.exports = exports;
